import { Button, Flex, Form } from "antd"
import React, { useEffect, useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { resendConfirmCode, verifyByPinCode } from "store/auth"
import { CustomForm } from "ui/Form"
import { CodeInput } from "ui/Input"
import { Text, Title } from "ui/Typography"
import { routes } from "router"
import useFormErrors from "hooks/useAntdFormErrors"
import { CustomInputError } from "ui/CustomInputError"
import ChangeContactModal from "../ChangeEmailPhoneNumber/ChangeContactModal"
import { toaster } from "components/common/Toast"
import styles from "./index.module.css"

const initialValue = ["", "", "", "", ""]

export const ConfirmEmail = () => {
  const { t } = useTranslation()
  const [initialCode, setInitialCode] = useState()
  const [searchParams] = useSearchParams()
  const email = searchParams.get("email")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, user } = useSelector((state) => {
    return state.auth
  })
  const [form] = Form.useForm()
  const [timer, setTimer] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [updatedEmail, setUpdatedEmail] = useState('')
  const handleCloseModal = () => {
    setIsModalOpen(false)
  }
  const onFinish = ({ code }) => {
    const fullCode = code.join("")
    if (fullCode.length === 5) {
      dispatch(verifyByPinCode(fullCode)).then((res) => {
        if (res?.success) {
          navigate(routes.confirmPhone(), {
            state: { phone_number: user.phone_number },
            replace: true
          })
        } else {
          navigate(routes.signInV2())
        }
      })
    }
  }
  useEffect(() => {
    if (timer === 0) return

    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)

    return () => clearInterval(interval)
  }, [timer])

  const { errors } = useFormErrors(form)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleResend = useCallback(
    (e) => {
      e?.preventDefault()
      dispatch(resendConfirmCode()).then((response) => {
        if (response?.success && response.message) {
          toaster.success(response.message)
        }
        setTimer(60)
        setInitialCode(initialValue)
      })
    },
    [dispatch]
  )
  return (
    <>
      <Title className="justify-center mt-4xl mb-m" level={2}>
        {t("verification.email_title")}
      </Title>
      <Text className="justify-center mb-4xl pb-s text-center">
        {t("verification.email_details")} {updatedEmail || email}
        <Button type="link" onClick={handleOpenModal}>
          {t("verification.change_email")}
        </Button>
      </Text>
      <CustomForm name="email-confirmation" layout="vertical" onFinish={onFinish} form={form}>
        <CodeInput
          form={form}
          name="code"
          initialValue={initialCode}
          help={
            !!errors?.pin_code && (
              <CustomInputError
                errorKey={errors.pin_code}
                customHandler={
                  errors.pin_code.includes("user.attributes.pin_code.expired")
                    ? () => (
                        <Button
                          className="pl-0 pb-0 mb-0 mt-0 pt-0 fw-normal"
                          color="primary"
                          variant="link"
                          size="medium"
                          onClick={handleResend}
                        >
                          {t("enter_code.resend_code")}
                        </Button>
                      )
                    : null
                }
              />
            )
          }
        />
        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large" disabled={loading} className="mt-5xl">
            {t("verification.verify")}
          </Button>
        </Form.Item>
      </CustomForm>
      <Flex justify="center">
        <div className={styles.resendContainer}>
          <Text>{t("enter_code.code_not_received")}</Text>
          {timer > 0 ? (
            <Text type="secondary">
              {t("enter_code.resend_in")}
              {timer} {t("enter_code.seconds")}
            </Text>
          ) : (
            <Link onClick={handleResend}>{t("enter_code.resend_code")}</Link>
          )}
        </div>
      </Flex>
      <ChangeContactModal open={isModalOpen} type="email" onCancel={handleCloseModal} setUpdatedEmail={setUpdatedEmail} />
    </>
  )
}
